<template>
    <div>
        <DCard
            v-if="beforeCustomerNotes.length !== 0"
            padding
            class="customer-notes-before-margin"
        >
            <template #default>
                <div
                    v-for="customerNoteElement in beforeCustomerNotes"
                    :key="customerNoteElement.id"
                    class="customer-notes"
                >
                    <div class="header">
                        <span>{{ setDateFormat(customerNoteElement.createdAt, 'YYYY-MM-DD hh:mm') }}</span>
                    </div>
                    <div class="body">
                        <div>
                            <NoteContent :note-parts="customerNoteElement.note" />
                        </div>
                    </div>
                </div>
            </template>
        </DCard>
        <DCard
            padding
        >
            <NotesForm
                :customer-note="customerNote"
                :errors="errors"
                @submit="updateNote"
            />
        </DCard>
        <DCard
            v-if="afterCustomerNotes.length !== 0"
            padding
            class="customer-notes-after-margin"
        >
            <template #default>
                <div
                    v-for="customerNoteElement in afterCustomerNotes"
                    :key="customerNoteElement.id"
                    class="customer-notes"
                >
                    <div class="header">
                        <span>{{ setDateFormat(customerNoteElement.createdAt, 'YYYY-MM-DD hh:mm') }}</span>
                    </div>
                    <div class="body">
                        <div>
                            <NoteContent :note-parts="customerNoteElement.note" />
                        </div>
                    </div>
                </div>
            </template>
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import NotesForm from '~@/Components/Customers/Notes/Form'
import NoteContent from '~@/Components/Customers/NoteContent'

export default {
    name: 'CustomerNotesEdit',
    components: {
        NoteContent,
        NotesForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customerId: {
            type: Number,
            default: 0
        },
        customerNote: {
            type: Object,
            default: () => { return {} }
        },
        customerNotes: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        beforeCustomerNotes () {
            return this.customerNotes.filter(note => note.createdAt < this.customerNote.createdAt)
        },
        afterCustomerNotes () {
            return this.customerNotes.filter(note => note.createdAt > this.customerNote.createdAt)
        }
    },
    methods: {
        updateNote (form) {
            form.put(this.$route('customers.customers.customer-notes.update', {
                customer: this.customerId,
                customer_note: this.customerNote.id
            }))
        }
    }
}
</script>

<style lang="scss" scoped>
.customer-notes {
    padding: 15px;

    &:not(:last-child) {
        border-bottom: 1px solid #D9DBE0;
    }

    & .header {
        display: grid;
        grid-template-columns: 1fr auto;
        margin-bottom: 10px;

        & span:nth-child(1) {
            font-weight: bold;
        }
    }

    & .body {
        display: grid;
        grid-template-columns: 1fr auto;
        word-break: break-all;

        & div:nth-child(1) {
            line-height: 1.5em;
        }
    }
}

.customer-notes-before-margin {
    margin-bottom: 25px;
}

.customer-notes-after-margin {
    margin-top: 25px;
}
</style>
